export default import.meta.ROLLDOWN_FILE_URL_XVPswOAB4hTpu4N6dOGvyw